require('./brokerMarketsCommentsView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const iframeResizer = require('iframe-resizer');

// @helpers
const { formatText, getLanguage, getFinalTitle } = require('core/i18n').i18n;

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @constants
const IFRAME_URL = `https://openbank-analisis.webfg.com/boletin/${getLanguage()}`;

class BrokerMarketsCommentsView extends React.Component {
    componentDidMount() {
        iframeResizer.iframeResizer();
    }

    render() {
        const breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-brokerMarketComments'),
                url: ''
            }
        ];
        return (
            <div className="broker-market-comments-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('broker-brokerMarketComments')}
                    />
                </OKCover>
                <div className="broker-market-comments-view__body">
                    <ContentBox customClassName="broker-market-comments-view__content-box">
                        <iframe
                            className="broker-market-comments-view__iframe"
                            src={IFRAME_URL}
                        />
                    </ContentBox>
                </div>
            </div>
        );
    }
}

module.exports.constructor = BrokerMarketsCommentsView;
module.exports.BrokerMarketsCommentsView = connect()(BrokerMarketsCommentsView);
